export function needRefresh(data) {
  return {
    type: 'NEED_REFRESH',
    data,
  };
}
